module.exports = __webpack_public_path__ + "img/indicator.c04691ce.svg";